import React, { useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import numWords from "num-words";
import Logo from "../../assets/icons/logo.png";
import { useState } from "react";
import { useEffect } from "react";
import { amountToWords, numberToWords } from "amount-to-words";

const floatConverter = (value) => {
  var str = value.toFixed(2);

  var num = parseFloat(str);

  return num;
};

const Invoice = ({ orderO, productsO }) => {
  const invoiceRef = useRef();

  var [products, setProducts] = useState([...productsO]);
  var [order, setOrder] = useState({ ...orderO });
  useEffect(() => {
    recalculateOrder();
  }, []);
  const recalculateOrder = () => {
    var productsArr = [...productsO];
    var orderObj = {
      total_before_tax: 0,
      cgst: 0,
      sgst: 0,
      igst: 0,
      total_after_tax: 0,
      total_cash_amount: 0,
      total_invoice_value: 0,
    };
    for (let index = 0; index < productsArr.length; index++) {
      const element = productsArr[index];
      productsArr[index].total_before_tax = floatConverter(
        element.quantity * element.price
      );
      productsArr[index].cgst = floatConverter(
        (productsArr[index].total_before_tax * element.cgst_slab) / 100 ?? 0
      );
      productsArr[index].sgst = floatConverter(
        (productsArr[index].total_before_tax * element.sgst_slab) / 100 ?? 0
      );
      productsArr[index].total_after_tax = floatConverter(
        productsArr[index].total_before_tax +
          productsArr[index].cgst +
          productsArr[index].sgst
      );
      orderObj.cgst = floatConverter(
        orderObj.cgst + productsArr[index].cgst ?? 0
      );
      orderObj.sgst = floatConverter(
        orderObj.sgst + productsArr[index].sgst ?? 0
      );
      orderObj.total_before_tax = floatConverter(
        orderObj.total_before_tax + productsArr[index].total_before_tax ?? 0
      );
    }
    orderObj.total_after_tax = floatConverter(
      orderObj.sgst + orderObj.cgst + orderObj.total_before_tax ?? 0
    );
    setProducts([...productsArr]);

    setOrder({
      ...orderO,
      ...orderObj,
    });
  };

  const downloadPDF = () => {
    const input = invoiceRef.current;
    html2canvas(input, { scale: 2, useCORS: true, allowTaint : false, }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`${order.invoice_number}.pdf`);
    });
  };


    const amountInWord = (value = 0)=>{
  
      var text = "";
      var res =amountToWords(value, 2);
      console.log("res", res);
      
       text = `${res.numberInWords} Rupees`;
      if(res.decimalInWords){
        text = `${text} and ${res.decimalInWords} Paisa`;
      }
      return text;
    }
  

  return (
    <div className="p-6">
      <button
        onClick={downloadPDF}
        className="mb-4 bg-blue-600 text-white px-4 py-2 rounded"
      >
        Download PDF
      </button>
      <div
        className="border"
        style={{
          width: "850px",
        }}
      >
        <div
          ref={invoiceRef}
          className="bg-white text-black max-w-4xl mx-auto  p-10 text-sm font-sans"
        >
          {/* Header */}
            <img
              crossorigin="anonymous" 
              src={order?.company?.logo ??Logo}
              alt={"First Floor Infotech Private Limited"}
              className="text-xl font-bold uppercase mb-10 object-contain"
              width={350}
            />
          <div className="flex justify-between items-start border-b pb-4">
            <div>
              <h1 className="text-3xl font-bold uppercase mb-3">
                Delivery Challan
              </h1>
              <h3 className="text-xl font-bold uppercase">
                No:# {order.invoice_number}
              </h3>
              <p className="text-mb">Date: {order.order_date}</p>
            </div>
            <div className="text-right">
              <h2 className="font-semibold capitalize">
               {order?.company?.name ??"First Floor Infotech Private Limited"}
              </h2>
              <p className="w-[28ch] ">{order?.company?.address ??"518, North Park Avenue, Roopanagar, Mysore, Karnataka - 570026"}</p>
              <p>GSTIN: {order?.company?.gst_number ??"29AAFCF5274R1ZR"}</p>
              <p>Pan: {order?.company?.pan_number ??"AAFCF5274R"}</p>
              <p>Contact: {order?.company?.phone_number ?? "7892327428"}</p>
            </div>
          </div>

          {/* Buyer / Shipping Info */}
          <div className="flex justify-between mt-4 border-b pb-4">
            <div className="max-w-[300px]">
              <h3 className="font-semibold mb-1">Billed To:</h3>
              <p className="font-semibold text-md uppercase mb-1">
                {order.customer_obj.billing_name}
              </p>
              <p>
                {order.customer_obj.billing_address},{" "}
                {order.customer_obj?.billingCity?.name},{" "}
                {order.customer_obj?.billingState?.name}
              </p>
              <p>Pincode: {order.customer_obj.billing_pincode}</p>
              <p>GSTIN: {order.customer_obj.gst_number}</p>
              <p>
                Place of Supply:
                {order.customer_obj?.billingState?.name} ({" "}
                {order.customer_obj?.billingState?.code})
              </p>
              <p>Phone: {order.customer_obj.contact_number}</p>
            </div>
            <div className="w-[250px]">
              <div className="max-w-[250px]">
                <h3 className="font-semibold">Shipped To:</h3>
                <p className="font-semibold mb-1">
                  {order.customer_obj.customer_delivery_addresses?.name}
                </p>
                <p>
                  {order.customer_obj.customer_delivery_addresses?.address},
                  {order.customer_obj.customer_delivery_addresses?.city.name},{" "}
                  {order.customer_obj.customer_delivery_addresses?.state.name},
                </p>
                <p>
                  Pincode:{" "}
                  {order.customer_obj.customer_delivery_addresses?.pincode}
                </p>
                <p>
                  State:{" "}
                  {order.customer_obj.customer_delivery_addresses.state?.name} (
                  {order.customer_obj.customer_delivery_addresses.state?.code})
                </p>
                <p>Transport Vehical No: {order.transport_vehical_number}</p>
              </div>
            </div>
          </div>

          {/* Products Table */}
          <table className="w-full border-collapse mt-4 text-xs">
            <thead>
              <tr className="bg-gray-200">
                <th className="border px-2 py-1">#</th>
                <th className="border px-2 py-1">Name</th>
                <th className="border px-2 py-1">HSN</th>
                <th className="border px-2 py-1">Qty</th>
                <th className="border px-2 py-1">Rate</th>
                <th className="border px-2 py-1">Total Before Tax</th>
                {order.cgst > 0 && <th className="border px-2 py-1">CGST</th>}
                {order.sgst > 0 && <th className="border px-2 py-1">SGST</th>}
                <th className="border px-2 py-1">Amount</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p, i) => (
                <tr key={p.id}>
                  <td className="border px-2 py-1 text-center">{i + 1}</td>
                  <td className="w-[25ch] border px-2 pt-1 pb-2">{p.name} </td>
                  <td className="w-[8ch] border px-1 py-1 text-center">
                    {p.hsn_code}
                  </td>
                  <td className="border w-[3ch] px-2 py-1 text-center">
                    {p.quantity}
                  </td>
                  <td className="border w-[10ch]  px-2 py-1 text-center">
                    ₹{p.price}
                  </td>
                  <td className="border  w-[13ch]  px-2 py-1 text-center">
                    ₹{p.total_before_tax}
                  </td>
                  {order.cgst > 0 && (
                    <td className="border w-[13ch]  px-2 py-1 text-center">
                      {p.cgst_slab}% | ₹{p.cgst}
                    </td>
                  )}

                  {order.sgst > 0 && (
                    <td className="border  w-[13ch]  px-1 py-1 text-center">
                      {p.sgst_slab}% | ₹{p.sgst}
                    </td>
                  )}

                  <td className="border px-2 py-1 text-right">
                    ₹{p.total_after_tax}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Totals */}
          <div className="flex justify-end mt-6">
            <div className="text-right">
              <p>Sub Total: ₹{order.total_before_tax}</p>
              {order.cgst > 0 && <p>CGST: ₹{order.cgst}</p>}
              {order.sgst > 0 && <p>SGST: ₹{order.sgst}</p>}
              <p className="font-bold text-base">
                Grand Total: ₹{order.total_after_tax}
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-6 text-xs border-t pt-2">
            <p>
              Amount in Words:{" "}
              <em className="capitalize">
                Indian Rupees {amountInWord(order.total_after_tax)} Only.
              </em>
            </p>

            <div className="flex justify-between mt-[150px]">
              <p>Customer Signature</p>
              <p>Authorized Signatory</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const DeliveryInvoiceModal = ({
  isOpen = false,
  onClose = () => {},
  order = {},
  products = [],
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-5"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-[60rem] w-full h-full md:p-6 p-4 relative overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <Invoice orderO={order} productsO={products} />
          </div>
        </div>
      )}
    </>
  );
};

export default DeliveryInvoiceModal;
